<div class="text-[#1b1b16] font-semibold flex sm:flex-col md:flex-row justify-center items-center md:px-4 sm:px-0">
    <span class="text-[13px] sm:text-lg">{{ titleCase(moduleTitle) }}</span>
    <span class="text-[#B1AFCD66] px-1 hidden md:inline" *ngIf="categoriaTitleInfo"> | </span>
    <span class="text-base hidden md:inline sm:flex" *ngIf="categoriaTitleInfo">{{ categoriaTitleInfo }}</span>
    <span class="text-[#17162266] px-1 sm:hidden md:inline" *ngIf="pageTitleInfo"> | </span>
    <span class="text-base" *ngIf="pageTitleInfo">{{ pageTitleInfo }}</span>
    <span class="text-[#B1AFCD66] px-1 sm:hidden md:inline" *ngIf="subMenuTitleInfo"> | </span>
    <span class="text-sm" *ngIf="subMenuTitleInfo" [innerHTML]="subMenuTitleInfo"></span>
</div>
